module.exports = __webpack_public_path__ + "img/supplier_list.9c14efbd.png";